module.exports = __webpack_public_path__ + "img/24.b6f5864f.jpg";